export const selectOrderInfo = store => store.ordersStore.orderInfo;
export const selectOrderById = store => store.ordersStore.currentOrder;
export const selectOrderIsLoading = store => store.ordersStore.isLoading;
export const selectOrderIsError = store => store.ordersStore.isError;